var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "icons8_task_planning_32px",
    width: 40,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAr1JREFUWEftl01IFGEYx//P7I6frX1on1QO0iWWAvFjtuxSQZ3yKLlGEQUpREGQly7RIYjACvogSCJwd6GOHiq8eAjcEaWyjCBkXbBDoEJusaz78cSMbu5uszuvOrUeek8zzPPO83v/z9cMMTOKuWhNAhBRQVHGn7tLKpKVN4jppGFI5Juei19vvDAaX66apgpYAYT8nlsE7s5yRnRTaQ9eswUgHPCIJQbjCIEcTDwg4ljxan9Ia6qAKEB8w6Yy57coUWk0+lcAMokn/aqhitkpMp2b2RXaW1CBNQkgInWuUrYqUDQAUcdmdrYo8B+g6ArkxjF9nw9MtIRX3Af+OYBoCML+Jjez4xyIjwHYurivxhiaKbhrT2mfMt8lrIAVwMjjBrmmSu4BcxcARx77JAP3ZyKJq+nRLQywjByYJ+ApET/hVMmEcXKO7Uk6pPPEOAtABvjVdCTZqkPYDfAVJJ1Q2ofemikQ9qkNTOgHsB2MB0qHdlEYIF8IjJhDeg8gngLUOq82lrY1nYyBA/XgVNAIk0T7Vg0Q8qt3CbgMpjtKR/CK1WjWn4d86j0iXAK4RxjAKgck4qbd7cMjQgABj0rMQYA+2gZQloiu23Z67KcIwOfeFldZeWIOQEQYIF8OTPrVHwAqK5zlri1tg/q1scK+QxuZ4rNmX1Ff+tQqWcJ3uwD0xrIX4IOKd3hIdzj1rLk6IWMAoHoAo4pXa8w8QLjP08ISvwEwvmoFlpJwoawWkszTRcQPAbxzOKWju9qGDCWW1PE8YuJOyyS06n7ZzzmWAjWnyzAUaO6U5/Fi55nhmay8WCpDiSEVLsPlARjW4o0IuK14te4V/RnlgulzYLPL2c/AcQC/W3FsffUH3bZ0dnp/VitmvKzdUd5KhwcTtgDoTmwdRlb/hoVCkzGOdTXqFm0nAH5NKerNHce/AG3iKxpsslvNAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaningIcon);
export default __webpack_public_path__ + "static/media/planingIcon.97d1ef165a5260c97e5c4bedde602d09.svg";
export { ForwardRef as ReactComponent };